import { fromPromise } from '../common/rxjs/observable';
import hublessAuth from 'hub-http/clients/noPortalApiClient';
const BASE_URL = 'userpreferences/v1/emails/login';
export default class API {
  static add(email) {
    return fromPromise(hublessAuth.post(`${BASE_URL}/${email}`));
  }
  static delete(email) {
    return fromPromise(hublessAuth.delete(`${BASE_URL}/${email.id}`));
  }
  static resendVerification(email) {
    return fromPromise(hublessAuth.post(`${BASE_URL}/${email.id}/verify/resend`));
  }
  static setPrimary(email) {
    return fromPromise(hublessAuth.post(`${BASE_URL}/${email.id}/primary`));
  }
}